import { render, staticRenderFns } from "./ActivityBookingNew.vue?vue&type=template&id=2f8014e1&scoped=true&"
import script from "./ActivityBookingNew.vue?vue&type=script&lang=js&"
export * from "./ActivityBookingNew.vue?vue&type=script&lang=js&"
import style0 from "./ActivityBookingNew.vue?vue&type=style&index=0&id=2f8014e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8014e1",
  null
  
)

export default component.exports